import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import axios from "axios";

const BanktransactionListComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity} = useParams();
  const [Banktransactions, setBanktransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const [typeDict, setTypeDict] = useState({});
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });
  const roles = ((localStorage.getItem('roles') || '') + '').toUpperCase();
  const canRead = roles.includes('ROLE_BANK_TRANSACTION_READ');
  const canWrite = roles.includes('ROLE_BANK_TRANSACTION_WRITE');

  const loadTypeDictionary = () => {
  apiCall('get', '/api/v2/dictionary/bank-transaction-type')
    .then(res => {
      const dictArr = res?.data?.data || [];

      const map = {};
      dictArr.forEach(item => {
        if (item && item.key !== undefined) {
          map[item.key] = item.value;
        }
      });

      setTypeDict(map);
    })
    .catch(() => {
      setTypeDict({});
    });
  };

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    if (!canRead) {
      return;
    }
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      if (query && !query.startsWith('?')) query = '?' + query;
      const url = '/api/v2/bank_transaction' + query;
      console.log('BANKTRANSACTION URL:', url);
      apiCall('get', '/api/v2/bank_transaction' + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setBanktransactions(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {localStorage.getItem('roles').toString().includes('role_bank_transaction_write') &&
          <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                  tooltip={t('edit')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if(entity === 'bank-transaction') {
                      history.push('/finance/bank-transaction/edit/' + rowData.id)
                    }
                  }}/>
        }
        {/* {localStorage.getItem('roles').toString().includes('role_') &&
          <Button icon="pi pi-trash" className="p-button-danger"
                  tooltip={t('delete')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if (window.confirm('A törlés megerősítésére van szükség!')) {
                      setLoading(true);
                      apiCall('delete', '/api/v2/bank_transaction/' + rowData.id)
                        .then(response => {
                          window.App.toastShow('success', 'Sikeres törlés!');
                          window.App.setState({rerenderBanktransactionList: Math.random()})
                        })
                        .catch(error => {
                          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                        })
                        .finally(() => {
                          setLoading(false);
                        })
                    }
                  }}
          />
        } */}
      </React.Fragment>
    );
  }

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderBanktransactionList])

  useEffect(() => {
    loadTypeDictionary();
  }, []);

  return (
    <>
      {!canRead ? (
        <div className="p-mt-5 p-text-center">
          <h3 className="p-mt-3">{props.t('bankTransactionsNoPermission')}</h3>
        </div>
      ) : (

      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={Banktransactions} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
      >
        {/* <Column field="name" header={t('columnName')} sortable filter></Column>




        <Column field="created_at" header={t('columnCreatedAt')} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.created_at)}</>
          )
        }}></Column>
        <Column field="updated_at" header={t('columnUpdatedAt')} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.updated_at)}</>
          )
        }}></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column> */}

        <Column field="bank_account.name" header={t('columnBankAccount')} bodyClassName="col-body-font-bold" sortable filter body={(row) => row?.bank_account?.name}></Column>
        <Column field="type" header={t('columnType')} bodyClassName="col-body-font-bold" sortable filter body={(row) => {
          if (row?.type) {
            return typeDict[row.type] || row.type;
          }
          if (!row?.type && row?.type_hint) {
            return (
              <span className="text-muted">{row.type_hint}</span>
            )
          }
          
          return '';
        }}
        />


        <Column field="partner.name" header={t('columnPartner')} sortable filter body={(row) => {
            if (!row?.partner || !row.partner.name) {
              return <i className="pi pi-times text-danger"></i>;
            }
            return (
              <span style={{ fontWeight: 600 }}>
                {row.partner.name}
              </span>
              );
          }}
        />

        <Column field="amount" header={t('columnAmount')} sortable filter body={(row) => {
            const num = Number(row?.amount);
            if (row?.amount === null || row?.amount === undefined || isNaN(num)) return '';
            return (
              <span
                style={{
                  fontWeight: 600,
                  color: num >= 0
                    ? 'var(--green-500, #22c55e)'
                    : 'var(--red-500, #ef4444)'
                }}
              >
                {window.App.currencyFormatter(row?.currency, num)}
              </span>
            );
          }}
        />



        <Column field="currency" header={t('columnCurrency')} sortable filter body={(row) => row?.currency}></Column>
        <Column field="booking_date" header={t('columnPosted')} sortable filter body={(row) => window.App.formatDateValue(row?.booking_date)}></Column>
        <Column field="value_date" header={t('columnValueDate')} sortable filter body={(row) => window.App.formatDateValue(row?.value_date)}></Column>
        <Column field="comment" header={t('columnMessage')} sortable filter body={(row) => row?.comment}></Column>

        {canWrite && (
          <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column> 
        )}
      </DataTable>
      )}
    </>
  )
}
 export default withTranslation('common')(BanktransactionListComponent);
